import { tns } from 'tiny-slider/src/tiny-slider';

export default (() => {
  
    $('.reasons-to-stay').each(function() {
        tns({
            container: $(this)[0],
            autoplay: true,
            autoplayHoverPause: true,
            autoplayTimeout: 5000,
            autoplayButtonOutput: false,
            speed: 3000,
            touch: true,
            nav: true,
            navPosition: 'bottom',
            controls: false,
            items: 1,
            loop: true,
        });
    });
});



// WEBPACK FOOTER //
// ./scripts/components/reasons-to-stay.js